import {
  AlarmIcon,
  AssignmentIcon,
  DescriptionIcon,
  MessageIcon,
  NoteAddIcon,
  NotInterestedIcon,
  PlaceIcon,
  RateReviewIcon,
  SvgIconProps,
  ThumbUpIcon,
} from '@freighthub/silhouette-core'
import { Component, ComponentType } from 'react'

export const DOCUMENT_ICON = 'document-icon'
const DOCUMENT_ADD_ICON = 'document-add-icon'
const MESSAGE_ICON = 'message-icon'
export const CHANGE_ICON = 'change-icon'
export const WARNING_ICON = 'warning-icon'
export const PIN_ICON = 'pin-icon'
export const ESTIMATED_ICON = 'estimated-icon'
export const CONFIRMED_ICON = 'confirmed-icon'
export const QUOTE_ICON = 'quote-icon'

export type TIconType =
  | 'document-icon'
  | 'document-add-icon'
  | 'change-icon'
  | 'message-icon'
  | 'warning-icon'
  | 'pin-icon'
  | 'estimated-icon'
  | 'confirmed-icon'
  | 'quote-icon'

type TIconElementProps = {
  iconType: string
} & SvgIconProps

export class ActivityFeedIcon extends Component<TIconElementProps> {
  get icon(): ComponentType<SvgIconProps> | null {
    switch (this.props.iconType) {
      case CHANGE_ICON:
        return RateReviewIcon
      case DOCUMENT_ICON:
        return DescriptionIcon
      case DOCUMENT_ADD_ICON:
        return NoteAddIcon
      case MESSAGE_ICON:
        return MessageIcon
      case WARNING_ICON:
        return NotInterestedIcon
      case PIN_ICON:
        return PlaceIcon
      case ESTIMATED_ICON:
        return AlarmIcon
      case CONFIRMED_ICON:
        return ThumbUpIcon
      case QUOTE_ICON:
        return AssignmentIcon
      default:
        return null
    }
  }
  render() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { iconType, color = 'action', ...rest } = this.props
    const IconElement = this.icon
    if (!IconElement) {
      return null
    }
    return <IconElement color={color} {...rest} />
  }
}
